
export class FreebieIdRequest {
    freebieId: number;
    username: string;

    /**
     * 
     * @param freebieId 
     * @param username 
     */
    constructor(freebieId: number, username: string) {
        this.freebieId = freebieId;
        this.username = username;
    }
}